/**
 * Input-mode resolver — maps an intent card to the dialog's input contract.
 *
 * Reads `intent.input_mode` (data-cards-schema column on prompt_cards). Falls back
 * to `getUiInputMode(intent.execution_mode)` from the platform dispatch matrix for
 * legacy intents whose `input_mode` column is null.
 *
 * The A+B->C workspace (dialog-shell.js) is one layout for every intent, so the
 * per-mode dialog renderers this file used to hold are gone — slot visibility is
 * now driven directly off `input_mode` + `requires_second_image`. why → ADR-005 2.6.0.
 */

import { getUiInputMode } from '@mamamiya/platform/cards/execution-mode-matrix.js'

/**
 * Resolve the effective input_mode for an intent card.
 * @param {Object} intent
 * @returns {'image'|'text'|'image+text'|'client_edit'}
 */
export function resolveInputMode(intent) {
  if (!intent) return 'image'
  if (intent.input_mode) return intent.input_mode
  const fromExecution = getUiInputMode(intent.execution_mode)
  return fromExecution || 'image'
}
